// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".module[data-v-243996af]{margin-bottom:100px}@media only screen and (max-width:599.98px){.module[data-v-243996af]{margin-bottom:50px}}.module .hover-hand[data-v-243996af]{cursor:pointer}.module__text h2[data-v-243996af]{font-size:3rem;max-width:20ch;line-height:1.25}.module__text p[data-v-243996af]{max-width:40ch}", ""]);
// Exports
module.exports = exports;
